/* Dick Carriers — Rebuy-style cart: free-ship bar, pack nudge, colorway cross-sell */
(function(){
  function money(c){return '$'+(c/100).toFixed(2).replace(/\.00$/,'');}
  function update(cart){
    document.querySelectorAll('[data-dc-ship]').forEach(function(el){
      var th=parseInt(el.dataset.threshold,10)||5000, t=cart.total_price||0;
      var fill=el.querySelector('[data-dc-ship-fill]'), msg=el.querySelector('[data-dc-ship-msg]');
      var pct=Math.max(0,Math.min(100,Math.round(t/th*100)));
      if(fill)fill.style.width=pct+'%';
      if(msg){msg.innerHTML = t>=th
        ? 'You’ve unlocked <b>free U.S. shipping</b> 🎉'
        : 'You’re <b>'+money(th-t)+'</b> from <b>free U.S. shipping</b>';}
    });
  }
  function updatePack(cart){
    var el=document.querySelector('[data-dc-pack]'); if(!el)return;
    var n=cart.item_count||0, t3=+el.dataset.t3, p3=+el.dataset.p3, t6=+el.dataset.t6, p6=+el.dataset.p6;
    if(n>0 && n<t3) el.textContent='Add '+(t3-n)+' more → '+t3+'-pack for $'+p3;
    else if(n>=t3 && n<t6) el.textContent='Add '+(t6-n)+' more → '+t6+'-pack for $'+p6;
    else if(n>=t6) el.textContent='Best pack value unlocked ✓';
    else el.textContent='';
  }
  var prodCache=null;
  function getProduct(){ if(prodCache) return Promise.resolve(prodCache);
    return fetch('/products.json?limit=1').then(function(r){return r.json();}).then(function(j){prodCache=j.products[0];return prodCache;}); }
  function buildUpsell(cart){
    var box=document.querySelector('[data-dc-upsell]'); if(!box)return;
    if(!cart.item_count){box.hidden=true;box.innerHTML='';return;}
    getProduct().then(function(prod){
      if(!prod)return;
      var inCart={}, firstSize=null;
      cart.items.forEach(function(i){(i.options_with_values||[]).forEach(function(o){if(o.name==='Color')inCart[o.value]=true;if(o.name==='Size'&&!firstSize)firstSize=o.value;});});
      var colorOpt=(prod.options||[]).find(function(o){return o.name==='Color';}); if(!colorOpt)return;
      var recs=[];
      colorOpt.values.forEach(function(color){
        if(inCart[color])return;
        var v=prod.variants.find(function(vv){return vv.option1===color&&(!firstSize||vv.option2===firstSize)&&vv.available;})||prod.variants.find(function(vv){return vv.option1===color&&vv.available;});
        if(v){var img=(prod.images||[]).find(function(im){return (im.variant_ids||[]).indexOf(v.id)>=0;})||prod.images[0];recs.push({color:color,id:v.id,img:img?img.src:''});}
      });
      recs=recs.slice(0,8);
      if(!recs.length){box.hidden=true;return;}
      box.hidden=false;
      var html='<div class="dc-upsell__h">Complete your pack — add another colorway</div><div class="dc-upsell__row">';
      recs.forEach(function(r){html+='<div class="dc-upsell__item"><span class="dc-upsell__img" style="background-image:url('+r.img+(r.img.indexOf('?')>-1?'&':'?')+'width=200)"></span><span class="dc-upsell__nm">'+r.color+'</span><button type="button" class="dc-upsell__add" data-add-id="'+r.id+'">+ Add</button></div>';});
      html+='</div>';
      box.innerHTML=html;
      box.querySelectorAll('[data-add-id]').forEach(function(btn){btn.addEventListener('click',function(){
        var id=+btn.getAttribute('data-add-id'); btn.disabled=true; btn.textContent='…';
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:id,quantity:1}]})})
          .then(function(){document.dispatchEvent(new CustomEvent('cart:build'));});
      });});
    });
  }
  function updateCount(c){document.querySelectorAll('[data-cart-count]').forEach(function(el){el.textContent=c.item_count;el.classList.toggle('cart-link__bubble--visible',c.item_count>0);});}
  function refresh(){fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(c){update(c);updatePack(c);buildUpsell(c);updateCount(c);}).catch(function(){});}
  var of=window.fetch;
  window.fetch=function(){
    var url=''; try{url=(arguments[0]&&arguments[0].url)||arguments[0]||'';}catch(e){}
    return of.apply(this,arguments).then(function(res){
      try{ if(/\/cart\/(add|change|update|clear)(\.js)?/.test(String(url))) setTimeout(refresh,350); }catch(e){}
      return res;
    });
  };
  document.addEventListener('DOMContentLoaded',refresh);
  document.addEventListener('click',function(e){var t=e.target.closest&&e.target.closest('#cart-icon-bubble,a[href="/cart"],.js-drawer-open-cart,[data-icon="cart"],.header__icon--cart');if(t)setTimeout(refresh,450);},true);
})();



/* bulletproof sticky header: move to <body> when stuck (escapes transformed ancestors) */
(function(){
  var header=document.querySelector('.site-header'); if(!header)return;
  var placeholder=document.createElement('div'); placeholder.setAttribute('data-dc-hph',''); 
  var moved=false, home=header.parentNode, next=header.nextSibling;
  function apply(){
    var y=window.scrollY||0, stuck=y>56;
    document.documentElement.classList.toggle('dc-stuck',stuck);
    document.documentElement.classList.toggle('dc-scrolled',y>60);
    // hide header on scroll down, reveal on scroll up
    var de=document.documentElement, ly=de.__dcLastY||0;
    if(y<90){ de.classList.remove('dc-hdr-hide'); }
    else if(y>ly+5){ de.classList.add('dc-hdr-hide'); }
    else if(y<ly-5){ de.classList.remove('dc-hdr-hide'); }
    de.__dcLastY=y;
    if(stuck && !moved){
      placeholder.style.height=header.offsetHeight+'px';
      home.insertBefore(placeholder,next);
      document.body.appendChild(header);
      moved=true;
    } else if(!stuck && moved){
      if(placeholder.parentNode)placeholder.parentNode.insertBefore(header,placeholder);
      if(placeholder.parentNode)placeholder.parentNode.removeChild(placeholder);
      moved=false;
    }
  }
  window.addEventListener('scroll',apply,{passive:true});
  window.addEventListener('resize',apply,{passive:true});
  apply();
})();


/* cart line remove (trash icon) — reuse Motion qty=0 flow, ajax fallback */
document.addEventListener('click',function(e){
  var btn=e.target.closest&&e.target.closest('.dc-cart-remove'); if(!btn)return;
  e.preventDefault(); e.stopPropagation();
  var item=btn.closest('.cart__item'); if(item){item.style.opacity='.4';item.style.pointerEvents='none';}
  var input=item&&item.querySelector('.js-qty__num');
  if(input){ input.value=0; input.dispatchEvent(new Event('change',{bubbles:true})); }
  else {
    var key=btn.getAttribute('data-key');
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:0})})
      .then(function(){document.dispatchEvent(new CustomEvent('cart:build'));setTimeout(function(){location.reload();},300);});
  }
},true);


/* Build-your-pack tier -> quantity */
document.addEventListener('click',function(e){
  var t=e.target.closest&&e.target.closest('.ryp-boost__t'); if(!t)return;
  e.preventDefault();
  var box=t.closest('[data-ryp-pack]')||t.closest('.ryp-boost');
  if(box)box.querySelectorAll('.ryp-boost__t').forEach(function(x){x.classList.remove('is-selected');});
  t.classList.add('is-selected');
  var qty=parseInt(t.getAttribute('data-qty')||'1',10)||1;
  var q=document.querySelector('form[action*="/cart/add"] [name="quantity"], input[name="quantity"]');
  if(q){q.value=qty;q.dispatchEvent(new Event('input',{bubbles:true}));q.dispatchEvent(new Event('change',{bubbles:true}));}
});


/* dc-reveal motion: fade/rise sections on scroll */
(function(){
  if(!('IntersectionObserver' in window))return;
  if(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  function run(){
    var secs=[].slice.call(document.querySelectorAll('#MainContent > .shopify-section'));
    secs.forEach(function(s,i){ if(i===0)return; if(!s.classList.contains('dc-reveal'))s.classList.add('dc-reveal'); });
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('dc-in');io.unobserve(e.target);}});},{threshold:.1,rootMargin:'0px 0px -6% 0px'});
    document.querySelectorAll('.dc-reveal:not(.dc-in)').forEach(function(s){io.observe(s);});
  }
  if(document.readyState!=='loading')run(); else document.addEventListener('DOMContentLoaded',run);
})();
